import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByReferralCSV from './StatisticsByReferralCSV';
import {
    getData,
    getHeaderName
} from './StatisticsByReferralCSV.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: getData,
    headerName: getHeaderName
});

const StatisticsByReferralCSVComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByReferralCSV);

export default StatisticsByReferralCSVComponent;
